import { render, staticRenderFns } from "./LeadsTable.vue?vue&type=template&id=3804196e&scoped=true"
import script from "./LeadsTable.vue?vue&type=script&lang=ts"
export * from "./LeadsTable.vue?vue&type=script&lang=ts"
import style0 from "./LeadsTable.vue?vue&type=style&index=0&id=3804196e&prod&scoped=true&lang=scss"
import style1 from "./LeadsTable.vue?vue&type=style&index=1&id=3804196e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3804196e",
  null
  
)

export default component.exports